enum AppPlatform {
    ANDROID = 'android',
    HUAWEI = 'huawei',
    IOS = 'ios',
    WEB = 'web',
}

export default AppPlatform